<template>
  <el-dialog
    :title="title"
    width="60%"
    :visible.sync="visible"
    :before-close="handleClose"
    @close="closeDialog"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-row>
        <el-col :span="14">
          <el-form-item label="课时名称">
            <el-input
              v-model="form.name"
              maxlength="100"
              placeholder="最长可输入100字"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" v-if="type == '1'">
          <div style="margin: 10px 0 0 20px">
            <div style="font-size: 12px">
              <el-checkbox v-model="continuousInput">连续录入</el-checkbox>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-form-item label="课时类型" v-if="ifTypes">
        <el-radio-group v-model="form.types">
          <el-radio :label="1" :disabled="(isTest && testTrue) || ifChecks"
            >课件</el-radio
          >
          <el-radio :label="2" :disabled="(isTest && testTrue) || ifChecks"
            >练习卷</el-radio
          >
          <el-radio :label="3" :disabled="(isTest && testTrue) || ifChecks"
            >测验卷</el-radio
          >
          <el-radio :label="6" :disabled="(!isTest && !testTrue) || ifChecks"
            >考试卷</el-radio
          >
          <el-radio :label="4" :disabled="(isTest && testTrue) || ifChecks"
            >面授课</el-radio
          >
          <el-radio :label="5" :disabled="(isTest && testTrue) || ifChecks"
            >直播课</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="面授列表" v-if="ifLists">
        <el-select v-model="linkCourse" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.courseId"
            :label="item.courseName"
            :value="item.courseId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="直播列表" v-if="ifLists2">
        <el-select v-model="linkCourse2" placeholder="请选择">
          <el-option
            v-for="item in options2"
            :key="item.id"
            :label="item.videoTitle"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div v-if="form.types == 1" style="margin-left: 10px">
      <el-button
        :type="isLocalFile ? 'info' : 'primary'"
        @click="isLocalFile = false"
        >选择课程资源库文件</el-button
      >
      <el-button
        :type="isLocalFile ? 'primary' : 'info'"
        @click="isLocalFile = true"
        >上传本地资源文件</el-button
      >
      <CoursewareFile
        v-if="!isLocalFile"
        ref="CoursewareFile"
        :courseWareId="courseWareId"
        :institutionId="institutionId"
        :zyVideoSectionId="zyVideoSectionId"
        :videoDataId="videoDataId"
        @endSave="endSave"
      />
      <CourseLocalFile
        v-if="isLocalFile"
        ref="CourseLocalFile"
        :courseWareId="courseWareId"
        :institutionId="institutionId"
        :zyVideoId="zyVideoId"
        :videoDataId="videoDataId"
        @endSave="endSave"
      />
    </div>
    <div v-if="isExam" style="margin-left: 10px">
      <CourseAddExamPaper
        ref="CourseAddExamPaper"
        :examType="form.types"
        :courseWareId="courseWareId"
        :zyVideoSectionId="zyVideoSectionId"
        @endSave="endSave"
      />
    </div>
    <div v-if="form.types == 4" style="margin-left: 10px">
      <CourseAddOfflineCourse
        ref="CourseAddOfflineCourse"
        :mhmId="mhmId"
        :userType="userType"
        :zyVideoSectionId="zyVideoSectionId"
      />
    </div>
    <div v-if="form.types == 5" style="margin-left: 10px">
      <CourseAddOnlineCourse
        ref="CourseAddOnlineCourse"
        :mhmId="mhmId"
        :userType="userType"
        :zyVideoSectionId="zyVideoSectionId"
      />
    </div>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button
        type="primary"
        v-if="this.type == '1' || this.type == '3'"
        @click="save"
        >确 定</el-button
      >
      <el-button type="primary" v-if="this.type == '2'" @click="submitForm2"
        >确 定</el-button
      >
      <el-button type="" @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CoursewareFile from './Courseware-File'
import CourseLocalFile from './Course-localFile'
import CourseAddExamPaper from './Course-addExamPaper'
import CourseAddOfflineCourse from './Course-addOfflineCourse'
import CourseAddOnlineCourse from './Course-addOnlineCourse'
import { http } from '@/utils/axios'
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: ['userType', 'mhmId', 'zyVideoId'],
  name: 'CourseAddPeriod',
  components: {
    CoursewareFile,
    CourseLocalFile,
    CourseAddExamPaper,
    CourseAddOfflineCourse,
    CourseAddOnlineCourse,
  },
  data() {
    return {
      showDialog: false,
      institutionId: '',
      courseWareId: '',
      testTrue: false,
      isTest: true,
      ifTypes: true,
      // ifLists: false,
      // ifLists2: false,
      // linkCourse: '',
      // linkCourse2: '',
      // options: [],
      // options2: [],
      visible: false,
      form: {
        name: '',
        types: '',
      },
      title: '',
      type: '',
      page: 0,
      page2: 0,
      continuousInput: true,
      isLocalFile: false,
      zyVideoSectionId: '',
      childIs: '',
      isExam: false,
      videoDataId: '',
      ifChecks: false,
    }
  },
  watch: {
    'form.types': {
      handler(newVal) {
        if (newVal == 2 || newVal == 3 || newVal == 6) {
          this.isExam = true
        } else {
          this.isExam = false
        }
      },
    },
  },
  methods: {
    getList() {},

    // 初始化
    init(
      type,
      name,
      test,
      courseWareId,
      videoDataId,
      videoDataType,
      zyVideoSectionId,
      formType
    ) {
      //type1新增  2编辑课时名称 3编辑课件  name课件名字  test（1可选考试 2不可选 3仅选考试）
      this.showDialog = true
      this.type = type
      this.visible = true
      if (test == '1') {
        //都可以选
        this.isTest = true
        this.testTrue = false
      } else if (test == '2') {
        //没有考试
        this.isTest = false
        this.testTrue = false
      } else {
        //只有考试
        this.isTest = true
        this.testTrue = true
      }
      if (type == '1') {
        this.ifTypes = true
        this.form.name = ''
        this.title = '添加课时'
        this.courseWareId = courseWareId
      } else if (type == '2') {
        this.ifTypes = false
        // this.ifLists = false
        // this.ifLists2 = false
        this.form.name = name
        this.title = '编辑课时'
      } else {
        this.continuousInput = false
        this.ifTypes = true
        this.ifChecks = true
        this.form.name = name
        this.title = '编辑课时'
        this.form.types = formType
        this.courseWareId = courseWareId
        this.videoDataId = videoDataId
        this.zyVideoSectionId = zyVideoSectionId
      }
    },
    // 获取当前机构
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        this.institutionId = data.data.id
      })
    },
    // chooseTypes(value) {
    //   if (value == '4') {
    //     this.ifLists = true
    //     this.ifLists2 = false
    //     this.options = []
    //     this.linkCourse = ''
    //     this.getTeacherCourseList()
    //   } else if (value == '5') {
    //     this.ifLists2 = true
    //     this.ifLists = false
    //     this.options2 = []
    //     this.linkCourse2 = ''
    //     this.getZyVideoList()
    //   } else {
    //     this.ifLists = false
    //     this.ifLists2 = false
    //   }
    // },

    // 获取面授列表
    // getTeacherCourseList() {
    //   this.page++
    //   let page = this.page * 1
    //   api
    //     .getTeacherCourseList({
    //       mhmId: this.mhmId,
    //       userType: this.userType,
    //       uid: this.getUId,
    //       page: '1',
    //       pageSize: '1000',
    //     })
    //     .then(({ data }) => {
    //       if (data.code == 100000) {
    //         this.options = data.data
    //       } else {
    //         this.$message({ type: 'error', message: data.msg })
    //       }
    //     })
    // },

    // 获取直播列表
    // getZyVideoList() {
    //   api
    //     .getZyVideoList({
    //       mhmId: this.mhmId,
    //       userType: this.userType,
    //       uid: this.getUId,
    //       page: '1',
    //       pageSize: '1000',
    //     })
    //     .then(({ data }) => {
    //       if (data.code == 100000) {
    //         this.options2 = data.data
    //       } else {
    //         this.$message({ type: 'error', message: data.msg })
    //       }
    //     })
    // },

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    async submitForm(linkCourseId) {
      if (this.form.name == '') {
        return this.$message({ type: 'error', message: `请输入名称` })
      }
      if (this.ifChecks) {
        //编辑课件
        if (this.form.types == '1') {
          if (this.isLocalFile) {
            this.$refs.CourseLocalFile.appendChild(this.zyVideoSectionId)
          } else {
            this.$refs.CoursewareFile.appendChild(this.zyVideoSectionId)
          }
        } else if (this.form.types == 4) {
          this.submitForm2(linkCourseId)
        } else if (this.form.types == 5) {
          this.submitForm2(linkCourseId)
        } else {
          this.$refs.CourseAddExamPaper.appendChild(this.zyVideoSectionId)
        }
      } else {
        //新增
        if (this.form.types == '4') {
          this.$emit('getLinkCourse', linkCourseId)
        } else if (this.form.types == '5') {
          this.$emit('getLinkCourse', linkCourseId)
        }
        this.$emit('getPeriodType', this.form.types)
        this.$emit('getPeriodName', this.form)
      }
    },
    //添加课时时,保存对应课时类型中选择的内容
    save() {
      if (this.form.types == 1) {
        if (this.isLocalFile) {
          this.childIs = 'CourseLocalFile'
          this.$refs.CourseLocalFile.save()
        } else {
          this.childIs = 'CoursewareFile'
          this.$refs.CoursewareFile.save()
        }
      } else if (this.form.types == 4) {
        this.$refs.CourseAddOfflineCourse.save()
      } else if (this.form.types == 5) {
        this.$refs.CourseAddOnlineCourse.save()
      } else {
        this.childIs = 'CourseAddExamPaper'
        this.$refs.CourseAddExamPaper.save()
      }
    },
    appendChild(zyVideoSectionId) {
      const child = this.childIs
      this.$refs[child].appendChild(zyVideoSectionId)
    },
    endSave() {
      if (this.ifChecks) {
        this.submitForm2()
      } else {
        this.$emit('endSave')
      }
      this.form.name = ''
      if (this.form.types === 6) {
        this.testTrue = true
      }
      this.form.types = ''
      this.isLocalFile = false
      if (!this.continuousInput) {
        this.visible = false
      }
    },
    submitForm2(linkCourseId) {
      if (this.form.name == '') {
        this.$message({ type: 'error', message: `请输入名称` })
      } else {
        this.visible = false
        if (this.form.types == '4') {
          this.$emit('getLinkCourse', linkCourseId)
        } else if (this.form.types == '5') {
          this.$emit('getLinkCourse', linkCourseId)
        }
        this.$emit('getPeriodType', this.form.types)
        this.$emit('editPeriodName', this.form)
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
  },
  created() {
    this.getList()
    this.getSchoolByUid()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  width: 60%;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
